import SeoLandingPage from "@/components/SeoLandingPage";

const GitMergeConflicts = () => <SeoLandingPage pageKey="gitMergeConflicts" />;

export default GitMergeConflicts;
